import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { isCustomizing } from 'state/selectors/help-center-preview';
import { ListOfPortals } from './list-of-portals';

const selector = createSelector(isCustomizing, (customizing) => ({
    isSidebarOpen: customizing,
}));

export default connect(selector, {})(ListOfPortals);
